var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
/**
 * The `atomic-layout-section` lets you identify various sections for the related `atomic-search-layout` or `atomic-commerce-layout` component.
 *
 * @slot default - The default slot where you can add child components to the section.
 */
let AtomicLayoutSection = class AtomicLayoutSection extends LitElement {
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ type: String, reflect: true })
], AtomicLayoutSection.prototype, "section", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'min-width' })
], AtomicLayoutSection.prototype, "minWidth", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'max-width' })
], AtomicLayoutSection.prototype, "maxWidth", void 0);
AtomicLayoutSection = __decorate([
    customElement('atomic-layout-section')
], AtomicLayoutSection);
export { AtomicLayoutSection };
